export default __webpack_public_path__ + "static/media/downangle_icon.95a05988.svg";